module.exports = __webpack_public_path__ + "static/17-289a0b20406d378fa0ae4be562e07890.png";